export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const ENDPOINTS = {
  AUTH: {
    SIGN_UP: '/signup',
    SIGN_IN: '/login',
    RESET_PASSWORD: '/reset_password',
  },
  PAGES: {
    INDEX: '/pages',
    ALL: '/pages/all',
  },
  USER_PROFILE: {
    INDEX: '/me',
    SETTINGS: '/me/settings',
    PASSWORD: '/me/password',
    BADGES: '/me/badges',
  },
  SUBSCRIPTION: {
    CANCEL: '/gumroad/cancel',
  },
};



// WEBPACK FOOTER //
// ./src/modules/api/endpoints.ts